import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Select extends React.PureComponent {
  render() {
    const { label, className = '', options, size = 'full', placeholder, invalid, hide, required, ...rest } = this.props;

    const forId = 'input_' + this.props.name;

    const classes = cx(className, styles.input, styles[size], {
      [styles.invalid]: invalid,
      [styles.hide]: hide,
    });

    return (
      <div className={classes}>
        {label ? (
          <label htmlFor={forId}>
            {label ? label : ''}&nbsp;{required ? <i>*</i> : null}
          </label>
        ) : null}

        <div className={cx(styles.group, styles.select)}>
          <select id={forId} {...rest} className={styles.singleSelect}>
            {placeholder ? <option value="">{placeholder}</option> : null}
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label || option.value}
              </option>
            ))}
          </select>
          <span className={styles.arrow}>▾</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/form/select.js